"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sliceKey = exports.reducer = exports.eventsProviderActions = exports.initialState = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const react_fast_compare_1 = __importDefault(require("react-fast-compare"));
const omit_1 = __importDefault(require("../../utils/functions/omit"));
const toolkit_2 = require("../../utils/@reduxjs/toolkit");
const api_1 = require("../../utils/api");
const slices_1 = require("../../utils/@reduxjs/slices");
const utils_1 = require("./utils");
const events_1 = require("../../utils/events");
const logger_1 = require("../../utils/logger");
const types_1 = require("../../utils/api/types");
const computeEventProbabilitiesByMarket_1 = require("../../utils/outcomes/computeEventProbabilitiesByMarket");
const constants_1 = require("./constants");
const REDUCER_KEY = 'eventsProvider';
// The initial state of the EventsProvider container
exports.initialState = (0, slices_1.getPreloadedState)(REDUCER_KEY, {
    events: {
        lastProbabilitiesTimestamp: {},
        lastProbabilitiesVersion: {},
        entries: {},
        fetchItems: api_1.requestInitialState,
        fetchItem: api_1.requestInitialState,
        fetchScheduledLiveEvents: api_1.requestInitialState,
    },
    eventProbabilitiesByMarket: {
        entries: {},
    },
    outcomes: {},
    marketCategoriesInfosByEvent: {
        entries: {},
    },
    eventProbabilitiesByVirtualMarket: {
        entries: {},
    },
    virtualCategoriesInfosByEvent: {
        entries: {},
    },
    eventsStatistics: {
        entries: {},
        fetchItem: api_1.requestInitialState,
    },
    tournaments: {
        entries: {},
        fetchItems: api_1.requestInitialState,
    },
    sse: {
        topEvent: {
            channel: null,
            status: api_1.initialStatusSSE,
            cursor: null,
        },
        eventsProbabilities: {
            channels: {},
            statuses: {},
            cursors: {},
        },
    },
    lists: {},
});
const eventsProviderSlice = (0, toolkit_2.createSlice)({
    name: REDUCER_KEY,
    initialState: exports.initialState,
    reducers: {
        fetchEvents(state, _action) {
            state.events.fetchItems.loading = true;
            state.events.fetchItems.error = null;
        },
        fetchFavouriteEvents(state, _action) {
            state.events.fetchItems.loading = true;
            state.events.fetchItems.error = null;
        },
        fetchEventsLive(state, _action) {
            state.events.fetchItems.loading = true;
            state.events.fetchItems.error = null;
        },
        fetchEventsLine(state, _action) {
            state.events.fetchItems.loading = true;
            state.events.fetchItems.error = null;
        },
        eventsLoaded(state, action) {
            (0, utils_1.updateStateWithEvents)(state, action.payload.resData.items);
        },
        fetchEventsSuccess(state, action) {
            (0, utils_1.updateStateWithEvents)(state, action.payload.resData.items);
            state.events.fetchItems.loading = false;
            state.events.fetchItems.error = null;
        },
        fetchEventsError(state, action) {
            state.events.fetchItems.loading = false;
            state.events.fetchItems.error = action.payload;
        },
        fetchTopLineLiveEvents() { },
        fetchScheduledLiveEvents(state, _action) {
            state.events.fetchScheduledLiveEvents.loading = true;
            state.events.fetchScheduledLiveEvents.error = null;
        },
        fetchScheduledLiveEventsSuccess(state, action) {
            state.events.entries = {
                ...state.events.entries,
                ...(0, slices_1.toIdsMap)(action.payload.resData.items),
            };
            state.events.fetchScheduledLiveEvents.loading = false;
            state.events.fetchScheduledLiveEvents.error = null;
        },
        fetchScheduledLiveEventsError(state, action) {
            state.events.fetchScheduledLiveEvents.loading = false;
            state.events.fetchScheduledLiveEvents.error = action.payload;
        },
        fetchLinkedEvents(_state, _action) { },
        fetchLinkedEventsAndComputeProbabilities(_state, _action) { },
        fetchEvent(state, _action) {
            const { eventId } = _action.payload.reqData;
            if (state.events.fetchItem[eventId] === undefined) {
                state.events.fetchItem[eventId] = { ...api_1.requestInitialState };
            }
            state.events.fetchItem[eventId].loading = true;
            state.events.fetchItem[eventId].error = null;
        },
        fetchEventEvery(state, _action) {
            const { eventId } = _action.payload.reqData;
            if (state.events.fetchItem[eventId] === undefined) {
                state.events.fetchItem[eventId] = { ...api_1.requestInitialState };
            }
            state.events.fetchItem[eventId].loading = true;
            state.events.fetchItem[eventId].error = null;
        },
        fetchEventSuccess(state, action) {
            const { id: eventId } = action.payload.resData;
            // Хоть и вызов success всегда идет после инит вызова fetchEvent,
            // мы не может гарантировать что регион не использует его неправильно
            if (state.events.fetchItem[eventId] === undefined) {
                state.events.fetchItem[eventId] = {
                    ...api_1.requestInitialState,
                    loading: false,
                    loaded: true,
                    error: null,
                };
            }
            else {
                state.events.fetchItem[eventId].loading = false;
                state.events.fetchItem[eventId].loaded = true;
                state.events.fetchItem[eventId].error = null;
            }
        },
        fetchEventError(state, action) {
            const { eventId } = action.payload;
            // Хоть и вызов error всегда идет после инит вызова fetchEvent,
            // мы не может гарантировать что регион не использует его неправильно
            if (state.events.fetchItem[eventId] === undefined) {
                state.events.fetchItem[eventId] = {
                    ...api_1.requestInitialState,
                    loading: false,
                    loaded: true,
                    error: action.payload.error,
                };
            }
            else {
                state.events.fetchItem[eventId].loading = false;
                state.events.fetchItem[eventId].loaded = true;
                state.events.fetchItem[eventId].error = action.payload.error;
            }
        },
        clearEvent(state, action) {
            delete state.events.entries[action.payload.eventId];
            delete state.events.lastProbabilitiesVersion[action.payload.eventId];
            delete state.eventsStatistics.entries[action.payload.eventId];
            delete state.outcomes[action.payload.eventId];
        },
        addEventIfNotExists(state, action) {
            const { event } = action.payload;
            if (state.events.entries[event.id] === undefined) {
                state.events.entries[event.id] = event;
            }
        },
        eventUpdated(state, action) {
            const { resData: event } = action.payload;
            state.events.entries[event.id] = event;
        },
        clearEventProbabilitiesByMarket(state, { payload: { eventId }, }) {
            delete state.eventProbabilitiesByMarket.entries[eventId];
            delete state.marketCategoriesInfosByEvent.entries[eventId];
        },
        computeEventProbabilitiesByMarket(state, action) {
            const { sportId, marketCategoriesMap, marketsMap, playersMap, categoryMarketInfosMap, eventCompetitors, eventProbabilities: { eventId, markets: eventMarkets }, eventStatus, clientType, } = action.payload;
            // Calls the utility function to compute and update event probabilities by market,
            // passing the current state's entries for merging with the new calculations.
            (0, computeEventProbabilitiesByMarket_1.computeEventProbabilitiesByMarket)({
                eventId,
                sportId,
                eventStatus,
                marketCategoriesMap,
                marketsMap,
                playersMap,
                categoryMarketInfosMap,
                eventCompetitors,
                eventMarkets: utils_1.EVENT_STATUSES_TO_CLEAR_OUTCOMES.includes(eventStatus)
                    ? []
                    : eventMarkets,
                eventProbabilitiesByMarketStore: state.eventProbabilitiesByMarket.entries,
                marketCategoriesInfosByEventStore: state.marketCategoriesInfosByEvent.entries,
                clientType,
            });
        },
        computeEventProbabilitiesByMarketV2(state, action) {
            const { eventId, changedMarkets, deletedMarkets, changedMarketCategoriesInfos, } = action.payload;
            const id = `${eventId}`;
            if (state.eventProbabilitiesByMarket.entries[id] === undefined) {
                Object.assign(state.eventProbabilitiesByMarket.entries, {
                    [id]: Object.freeze(changedMarkets),
                });
            }
            else {
                Object.assign(state.eventProbabilitiesByMarket.entries[id], Object.freeze(changedMarkets));
            }
            if (deletedMarkets.length) {
                deletedMarkets.forEach((marketKey) => {
                    delete state.eventProbabilitiesByMarket.entries[id][marketKey];
                });
            }
            if (changedMarketCategoriesInfos) {
                Object.assign(state.marketCategoriesInfosByEvent.entries, {
                    [id]: Object.freeze(changedMarketCategoriesInfos),
                });
            }
        },
        outcomesChanged(state, action) {
            const { eventId, outcomesDiff } = action.payload;
            if (state.outcomes[eventId] === undefined) {
                state.outcomes[eventId] = {
                    markets: outcomesDiff.newMarkets,
                    categories: [],
                };
            }
            // hadle changed categories
            if (outcomesDiff.changedCategories) {
                state.outcomes[eventId].categories = outcomesDiff.changedCategories;
            }
            // handle new markets
            if (Object.keys(outcomesDiff.newMarkets).length > 0) {
                Object.assign(state.outcomes[eventId].markets, outcomesDiff.newMarkets);
            }
            // handle changed markets
            for (const [marketId, changes] of Object.entries(outcomesDiff.changedMarkets)) {
                if (changes.statusChanged) {
                    state.outcomes[eventId].markets[marketId].tradingStatus =
                        changes.changedTradingStatus;
                }
                // handle changed order
                if (changes.changedOrder) {
                    state.outcomes[eventId].markets[marketId].outcomesOrder =
                        changes.changedOrder;
                }
                // handle updated outcomes
                Object.assign(state.outcomes[eventId].markets[marketId].outcomesByKey, changes.changedOutcomes);
                // handel deleted outcomes
                if (changes.deletedOutcomesKeys) {
                    for (const outcomeKey of changes.deletedOutcomesKeys) {
                        delete state.outcomes[eventId].markets[marketId].outcomesByKey[outcomeKey];
                    }
                }
            }
            // handle deleted markets
            for (const vMarketId of outcomesDiff.deletedMarketsIds) {
                delete state.outcomes[eventId].markets[vMarketId];
            }
        },
        clearOutcomes(state, action) {
            delete state.outcomes[action.payload.eventId];
            delete state.events.lastProbabilitiesVersion[action.payload.eventId];
        },
        computeEventProbabilitiesByMarketV3(state, action) {
            const { eventId, changedMarkets, deletedMarkets, changedCategoriesInfos, } = action.payload;
            const id = `${eventId}`;
            if (state.eventProbabilitiesByVirtualMarket.entries[id] === undefined) {
                Object.assign(state.eventProbabilitiesByVirtualMarket.entries, {
                    [id]: Object.freeze(changedMarkets),
                });
            }
            else {
                Object.assign(state.eventProbabilitiesByVirtualMarket.entries[id], Object.freeze(changedMarkets));
            }
            if (deletedMarkets.length) {
                deletedMarkets.forEach((marketKey) => {
                    delete state.eventProbabilitiesByVirtualMarket.entries[id][marketKey];
                });
            }
            if (changedCategoriesInfos) {
                Object.assign(state.virtualCategoriesInfosByEvent.entries, {
                    [id]: Object.freeze(changedCategoriesInfos),
                });
            }
        },
        updateProbabilitiesVersion(state, action) {
            const { eventId, version } = action.payload;
            state.events.lastProbabilitiesVersion[eventId] = version;
        },
        fetchEventSagaWithoutSideEffects(_state, _action) { },
        fetchEventProbabilities(_state, _action) {
            /**
             * @deprecated Use fetchEvent directly. Remove after PLAT-1314 release
             */
        },
        fetchTournaments(state, _action) {
            state.tournaments.fetchItems.loading = true;
            state.tournaments.fetchItems.error = null;
        },
        fetchTournamentsSuccess(state, action) {
            state.tournaments.entries = {
                ...state.tournaments.entries,
                ...(0, slices_1.toIdsMap)(action.payload.resData.items),
            };
            state.tournaments.fetchItems.loading = false;
            state.tournaments.fetchItems.error = null;
        },
        fetchTournamentsError(state, action) {
            state.tournaments.fetchItems.loading = false;
            state.tournaments.fetchItems.error = action.payload;
        },
        fetchEventStatistics(state, _action) {
            state.eventsStatistics.fetchItem.loading = true;
            state.eventsStatistics.fetchItem.error = null;
        },
        fetchEventStatisticsSuccess(state, action) {
            const { eventId, homeStatistics } = action.payload;
            const formattedEventStatistics = {
                ...action.payload,
                homeStatistics: {
                    ...homeStatistics,
                    periodScores: (0, events_1.sortEventPeriodScores)(homeStatistics === null || homeStatistics === void 0 ? void 0 : homeStatistics.periodScores),
                    periodStats: (homeStatistics === null || homeStatistics === void 0 ? void 0 : homeStatistics.periodStats) || [],
                },
            };
            state.eventsStatistics.entries[eventId] = formattedEventStatistics;
            state.eventsStatistics.fetchItem.loading = false;
            state.eventsStatistics.fetchItem.error = null;
        },
        fetchEventStatisticsError(state, action) {
            state.eventsStatistics.fetchItem.loading = false;
            state.eventsStatistics.fetchItem.error = action.payload;
        },
        subscribeTopEventsSSE(_state, _action) { },
        setTopEventsSSEStatus(state, { payload }) {
            state.sse.topEvent.status = payload;
        },
        unsubscribeTopEventsSSE(state, { payload = types_1.EEventMessageSSEType.CLOSED, }) {
            state.sse.topEvent.status.type = payload;
        },
        resubscribeTopEventsSSE(_state, _action) { },
        setTopEventsChannelSSE(state, { payload }) {
            state.sse.topEvent.channel = payload;
        },
        setUpdatesTopEventsSSE(state, { payload }) {
            const { event, probabilities, statistics } = payload;
            if (statistics) {
                if (state.events.entries[statistics.eventId]) {
                    state.events.entries[statistics.eventId].statistics =
                        statistics.statistics;
                }
            }
            else if (probabilities) {
                if (probabilities.markets.length &&
                    state.events.entries[probabilities.eventId]) {
                    const mergedMarketsProbabilities = (0, events_1.getEventMarketsProbabilities)({
                        newProbabilities: probabilities,
                        prevProbabilities: state.events.entries[probabilities.eventId].probabilities,
                    });
                    state.events.entries[probabilities.eventId].probabilities = {
                        ...probabilities,
                        markets: mergedMarketsProbabilities,
                    };
                }
            }
            else if (event) {
                const currentEvent = state.events.entries[event.id];
                if (currentEvent) {
                    if (event.outcomesCount === null) {
                        state.events.entries[event.id] = {
                            ...currentEvent,
                            ...(0, omit_1.default)(event, constants_1.SSE_TOP_EVENT_UPDATE_IGNORED_KEYS),
                        };
                    }
                    else if (event.outcomesCount >= 0) {
                        state.events.entries[event.id].outcomesCount = event.outcomesCount;
                    }
                    else {
                        console.error('sse invalid outcomes count', event);
                    }
                }
            }
        },
        subscribeEventProbabilitiesSSE(_state, _payload) { },
        unsubscribeEventProbabilitiesSSE(_state, _payload) { },
        setEventProbabilitiesChannelSSE(state, { payload }) {
            const { eventId, channel } = payload;
            if (!channel) {
                delete state.sse.eventsProbabilities.channels[eventId];
            }
            else {
                state.sse.eventsProbabilities.channels[eventId] = channel;
            }
        },
        setEventProbabilitiesUpdatesSSE(state, { payload: { probabilities, sseProbabilitiesUpdateOptimizationEnabled }, }) {
            if (state.events.entries[probabilities.eventId]) {
                (0, logger_1.logger)('previousProbabilities', (0, toolkit_1.current)(state.events.entries[probabilities.eventId])); // todo remove after PLAT-1174 tests
                const mergedMarketsProbabilities = sseProbabilitiesUpdateOptimizationEnabled
                    ? (0, events_1.getEventMarketsProbabilities)({
                        newProbabilities: probabilities,
                        prevProbabilities: state.events.entries[probabilities.eventId].probabilities,
                    })
                    : (0, events_1.getEventMarketsProbabilitiesDeprecated)({
                        newProbabilities: probabilities,
                        prevProbabilities: state.events.entries[probabilities.eventId].probabilities,
                    });
                (0, logger_1.logger)('mergedMarketsProbabilities', mergedMarketsProbabilities); // todo remove after PLAT-1174 tests
                state.events.entries[probabilities.eventId].probabilities = {
                    ...probabilities,
                    markets: mergedMarketsProbabilities,
                };
            }
        },
        resubscribeEventProbabilitiesSSE() { },
        reloadEventProbabilitiesSSE(_state, _payload) { },
        setCursorTopEvents(state, { payload }) {
            if (payload.cursor) {
                state.sse.topEvent.cursor = payload.cursor;
            }
        },
        setCursorEventProbabilitiesSSE(state, { payload }) {
            const { resData, reqData } = payload;
            const { eventId } = reqData;
            if (resData === null || resData === void 0 ? void 0 : resData.cursor) {
                state.sse.eventsProbabilities.cursors[eventId] = resData.cursor;
            }
        },
        setStatusEventProbabilitiesSSE(state, { payload }) {
            const { eventId, type, error } = payload;
            if (eventId) {
                state.sse.eventsProbabilities.statuses[eventId] = { type, error };
            }
        },
        eventChangedBySse(_state, _action) { },
        setEventListInfo(state, action) {
            const { config, filters } = action.payload;
            state.lists[action.payload.listKey] = {
                config,
                page1Number: 0,
                page2Number: 1,
                filters: filters || constants_1.eventListDefaultFilters,
                inactivePages: [],
                before: constants_1.emptyEventListPage,
                page1: constants_1.emptyEventListPage,
                page2: constants_1.emptyEventListPage,
            };
        },
        removeEventListInfo(state, action) {
            delete state.lists[action.payload.listKey];
        },
        // Initial fetch
        fetchEventList(state, action) {
            const { listKey } = action.payload;
            if (!state.lists[listKey])
                return;
            state.lists[listKey].before = constants_1.emptyEventListPage;
            state.lists[listKey].inactivePages = [];
            state.lists[listKey].page1 = { ...constants_1.emptyEventListPage, loading: true };
            state.lists[listKey].page2 = { ...constants_1.emptyEventListPage, loading: true };
        },
        fetchEventListPage1Success(_state, _action) { },
        fetchEventListSuccess(state, action) {
            const { listKey } = action.payload;
            if (!state.lists[listKey])
                return;
            const { page1, page2 } = action.payload;
            state.lists[listKey].before = constants_1.emptyEventListPage;
            state.lists[listKey].inactivePages = [];
            const newPage1IdsArray = (0, slices_1.toIdsArray)(page1.resData.items);
            state.lists[listKey].page1Number = 0;
            state.lists[listKey].page1 = {
                loading: false,
                polling: false,
                eventIds: newPage1IdsArray,
                paginationKeyBackward: page1.resData.paginationKeyBackward,
                paginationKeyForward: page1.resData.paginationKeyForward,
                paginationKey: page1.reqData.pageKey,
                paginationKeyDirection: page1.reqData.pageKeyDirection,
            };
            if (page2) {
                const newPage2IdsArray = (0, slices_1.toIdsArray)(page2.resData.items);
                state.lists[listKey].page2Number = 1;
                state.lists[listKey].page2 = {
                    loading: false,
                    polling: false,
                    eventIds: newPage2IdsArray,
                    paginationKeyBackward: page2.resData.paginationKeyBackward,
                    paginationKeyForward: page2.resData.paginationKeyForward,
                    paginationKey: page2.reqData.pageKey,
                    paginationKeyDirection: page2.reqData.pageKeyDirection,
                };
            }
            else {
                state.lists[listKey].page2 = constants_1.emptyEventListPage;
            }
        },
        fetchEventListError(state, action) {
            const { listKey } = action.payload;
            if (!state.lists[listKey])
                return;
            state.lists[listKey].page1 = constants_1.emptyEventListPage;
            state.lists[listKey].page2 = constants_1.emptyEventListPage;
        },
        // Fetch Next Page
        fetchEventListNextPage(state, action) {
            const { listKey } = action.payload;
            if (!state.lists[listKey])
                return;
            state.lists[listKey].page2.loading = true;
            state.lists[listKey].page2.polling = false;
            if (state.lists[listKey].page1.loading) {
                state.lists[listKey].page1.loading = false;
                state.lists[listKey].page1.polling = false;
                state.lists[listKey].page1Number += 1;
                state.lists[listKey].page2Number += 1;
            }
            state.lists[listKey].page1Number += 1;
            state.lists[listKey].page2Number += 1;
        },
        fetchEventListNextSuccess(state, action) {
            const { listKey } = action.payload;
            if (!state.lists[listKey])
                return;
            const { resData, reqData, page2Number } = action.payload;
            if (!state.lists[listKey].page2.loading ||
                page2Number !== state.lists[listKey].page2Number) {
                state.lists[listKey].page2.loading = false;
                return;
            }
            const { items } = resData;
            const newPage2IdsArray = (0, slices_1.toIdsArray)(items);
            const newPage1IdsArray = state.lists[listKey].page2.eventIds.filter((id) => !newPage2IdsArray.includes(id));
            const newBeforeIdsArray = [
                ...state.lists[listKey].before.eventIds,
                ...state.lists[listKey].page1.eventIds,
            ].filter((id) => !newPage2IdsArray.includes(id) && !newPage1IdsArray.includes(id));
            state.lists[listKey].before.eventIds = newBeforeIdsArray;
            state.lists[listKey].inactivePages.push({ ...state.lists[listKey].page1 });
            state.lists[listKey].page1 = {
                ...state.lists[listKey].page2,
                eventIds: newPage1IdsArray,
                polling: false,
                loading: false,
            };
            state.lists[listKey].page2 = {
                loading: false,
                polling: false,
                eventIds: newPage2IdsArray,
                paginationKeyBackward: resData.paginationKeyBackward,
                paginationKeyForward: resData.paginationKeyForward,
                paginationKey: reqData.pageKey,
                paginationKeyDirection: reqData.pageKeyDirection,
            };
        },
        fetchEventListNextError(state, action) {
            const { listKey } = action.payload;
            if (!state.lists[listKey])
                return;
            state.lists[listKey].page2.loading = false;
            state.lists[listKey].page1Number -= 1;
            state.lists[listKey].page2Number -= 1;
        },
        // Fetch Prev Page
        /**
         * @deprecated Use scrollUp actions
         */
        fetchEventListPrevPage(state, action) {
            const { listKey } = action.payload;
            if (!state.lists[listKey])
                return;
            state.lists[listKey].page1.loading = true;
            state.lists[listKey].page1.polling = false;
            if (state.lists[listKey].page2.loading) {
                state.lists[listKey].page2.loading = false;
                state.lists[listKey].page2.polling = false;
                state.lists[listKey].page1Number -= 1;
                state.lists[listKey].page2Number -= 1;
            }
            state.lists[listKey].page1Number -= 1;
            state.lists[listKey].page2Number -= 1;
        },
        /**
         * @deprecated Use scrollUp actions
         */
        fetchEventListPrevPageSuccess(state, action) {
            const { listKey } = action.payload;
            if (!state.lists[listKey])
                return;
            if (state.lists[listKey].before.eventIds.length === 0)
                return;
            const { resData, reqData, page1Number } = action.payload;
            if (!state.lists[listKey].page1.loading ||
                page1Number !== state.lists[listKey].page1Number) {
                state.lists[listKey].page1.loading = false;
                return;
            }
            const { items } = resData;
            const newPage1IdsArray = (0, slices_1.toIdsArray)(items);
            const newPage2IdsArray = state.lists[listKey].page1.eventIds.filter((id) => !newPage1IdsArray.includes(id));
            if (resData.paginationKeyBackward) {
                const newBeforeIdsArray = state.lists[listKey].before.eventIds.filter((id) => !newPage2IdsArray.includes(id) && !newPage1IdsArray.includes(id));
                state.lists[listKey].before.eventIds = newBeforeIdsArray;
            }
            else {
                state.lists[listKey].before.eventIds = [];
            }
            state.lists[listKey].inactivePages.pop();
            state.lists[listKey].page2 = {
                ...state.lists[listKey].page1,
                eventIds: newPage2IdsArray,
                loading: false,
                polling: false,
            };
            state.lists[listKey].page1 = {
                loading: false,
                polling: false,
                eventIds: newPage1IdsArray,
                paginationKeyBackward: resData.paginationKeyBackward,
                paginationKeyForward: resData.paginationKeyForward,
                paginationKey: reqData.pageKey,
                paginationKeyDirection: reqData.pageKeyDirection,
            };
        },
        /**
         * @deprecated Use scrollUp actions
         */
        fetchEventListPrevPageError(state, action) {
            const { listKey } = action.payload;
            if (!state.lists[listKey])
                return;
            state.lists[listKey].page1.loading = false;
            state.lists[listKey].page1Number += 1;
            state.lists[listKey].page2Number += 1;
        },
        resetListLoading(state, action) {
            const { listKey } = action.payload;
            if (!state.lists[listKey])
                return;
            state.lists[listKey].page1.loading = false;
            state.lists[listKey].page2.loading = false;
        },
        // Scroll Up
        scrollUp(state, action) {
            const { listKey, pageNumber } = action.payload;
            if (!state.lists[listKey])
                return;
            state.lists[listKey].page1.loading = true;
            state.lists[listKey].page1.polling = false;
            state.lists[listKey].page2.loading = true;
            state.lists[listKey].page2.polling = false;
            state.lists[listKey].page1Number = pageNumber;
            state.lists[listKey].page2Number = pageNumber + 1;
        },
        scrollUpPage1Success(_state, _action) { },
        scrollUpSuccess(state, action) {
            const { listKey } = action.payload;
            if (!state.lists[listKey])
                return;
            const { page1, page2 } = action.payload;
            state.lists[listKey].page1Number = page1.pageNumber;
            state.lists[listKey].page2Number = page1.pageNumber + 1;
            state.lists[listKey].page1 = {
                loading: false,
                polling: false,
                eventIds: (0, slices_1.toIdsArray)(page1.resData.items),
                paginationKeyBackward: page1.resData.paginationKeyBackward,
                paginationKeyForward: page1.resData.paginationKeyForward,
                paginationKey: page1.reqData.pageKey,
                paginationKeyDirection: page1.reqData.pageKeyDirection,
            };
            if (page2) {
                state.lists[listKey].page2 = {
                    loading: false,
                    polling: false,
                    eventIds: (0, slices_1.toIdsArray)(page2.resData.items),
                    paginationKeyBackward: page2.resData.paginationKeyBackward,
                    paginationKeyForward: page2.resData.paginationKeyForward,
                    paginationKey: page2.reqData.pageKey,
                    paginationKeyDirection: page2.reqData.pageKeyDirection,
                };
            }
            else {
                state.lists[listKey].page2 = constants_1.emptyEventListPage;
            }
            state.lists[listKey].inactivePages = state.lists[listKey].inactivePages.slice(0, page1.pageNumber);
        },
        scrollUpError(state, action) {
            const { listKey } = action.payload;
            if (!state.lists[listKey])
                return;
            state.lists[listKey].page1.loading = false;
            state.lists[listKey].page1.polling = false;
            state.lists[listKey].page2.loading = false;
            state.lists[listKey].page2.polling = false;
        },
        // Reset pagination
        /**
         * @deprecated Use scrollUp actions
         */
        resetEventListScroll(state, action) {
            const { listKey } = action.payload;
            if (!state.lists[listKey])
                return;
            state.lists[listKey].page1 = {
                ...constants_1.emptyEventListPage,
                eventIds: state.lists[listKey].before.eventIds,
            };
            state.lists[listKey].page2 = constants_1.emptyEventListPage;
            state.lists[listKey].before = constants_1.emptyEventListPage;
            state.lists[listKey].inactivePages = [];
            state.lists[listKey].page1Number = 0;
            state.lists[listKey].page2Number = 1;
        },
        // Polling
        pollEventList(state, action) {
            const { listKey } = action.payload;
            if (!state.lists[listKey])
                return;
            state.lists[listKey].page1.polling = true;
            state.lists[listKey].page2.polling = true;
        },
        pollEventListPage1Success(_state, _action) { },
        pollEventListSuccess(state, action) {
            const { listKey } = action.payload;
            if (!state.lists[listKey])
                return;
            const { page1, page2 } = action.payload;
            if (!state.lists[listKey].page1.polling ||
                page1.pageNumber !== state.lists[listKey].page1Number) {
                state.lists[listKey].page1.polling = false;
                state.lists[listKey].page2.polling = false;
                return;
            }
            const newPage1IdsArray = (0, slices_1.toIdsArray)(page1.resData.items);
            if (!(0, react_fast_compare_1.default)(state.lists[listKey].page1.eventIds, newPage1IdsArray)) {
                state.lists[listKey].page1 = {
                    loading: false,
                    polling: false,
                    eventIds: newPage1IdsArray,
                    paginationKeyBackward: page1.resData.paginationKeyBackward,
                    paginationKeyForward: page1.resData.paginationKeyForward,
                    paginationKey: page1.reqData.pageKey,
                    paginationKeyDirection: page1.reqData.pageKeyDirection,
                };
            }
            else {
                state.lists[listKey].page1.polling = false;
            }
            let newPage2IdsArray = [];
            if (page2) {
                newPage2IdsArray = (0, slices_1.toIdsArray)(page2.resData.items).filter((id) => !newPage1IdsArray.includes(id));
                if (!(0, react_fast_compare_1.default)(state.lists[listKey].page2.eventIds, newPage2IdsArray)) {
                    state.lists[listKey].page2 = {
                        loading: false,
                        polling: false,
                        eventIds: newPage2IdsArray,
                        paginationKeyBackward: page2.resData.paginationKeyBackward,
                        paginationKeyForward: page2.resData.paginationKeyForward,
                        paginationKey: page2.reqData.pageKey,
                        paginationKeyDirection: page2.reqData.pageKeyDirection,
                    };
                }
                else {
                    state.lists[listKey].page2.polling = false;
                }
            }
            else {
                state.lists[listKey].page2 = constants_1.emptyEventListPage;
            }
            const newBeforeIdsArray = state.lists[listKey].before.eventIds.filter((id) => !newPage1IdsArray.includes(id) && !newPage2IdsArray.includes(id));
            if (!(0, react_fast_compare_1.default)(state.lists[listKey].before.eventIds, newBeforeIdsArray)) {
                state.lists[listKey].before.eventIds = newBeforeIdsArray;
            }
        },
        pollEventListError(state, action) {
            const { listKey } = action.payload;
            if (!state.lists[listKey])
                return;
            state.lists[listKey].page1.polling = false;
            state.lists[listKey].page2.polling = false;
        },
        // Filters
        updateFilters(state, action) {
            const { listKey } = action.payload;
            if (!state.lists[listKey])
                return;
            state.lists[listKey].filters = {
                ...state.lists[listKey].filters,
                ...action.payload.filters,
            };
        },
        resetFilters(state, action) {
            const { listKey } = action.payload;
            if (!state.lists[listKey])
                return;
            state.lists[listKey].filters = constants_1.eventListDefaultFilters;
        },
        setFilters(state, action) {
            const { listKey } = action.payload;
            if (!state.lists[listKey])
                return;
            state.lists[listKey].filters = {
                ...action.payload.filters,
            };
        },
    },
});
exports.eventsProviderActions = eventsProviderSlice.actions, exports.reducer = eventsProviderSlice.reducer, exports.sliceKey = eventsProviderSlice.name;
//# sourceMappingURL=slice.js.map